import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';
import { Construction, Email, Phone } from '@mui/icons-material';

const UnderDevelopment = () => {
    return (
        <Paper
            sx={{
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                textAlign: 'center',
                height: '100%',
                justifyContent: 'center'
            }}
        >
            <Construction sx={{ fontSize: 60, color: 'warning.main' }} />
            <Typography variant="h4" color="text.secondary">
                Fejlesztés alatt
            </Typography>
            <Typography variant="body1" color="text.secondary">
                Ez a funkció jelenleg fejlesztés alatt áll. Kérjük, látogasson vissza később!
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
                <Typography variant="subtitle1" color="text.primary">
                    Kapcsolatfelvétel:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Email fontSize="small" color="primary" />
                    <Link href="mailto:office.sild@gmail.com" underline="hover">
                        office.sild@gmail.com
                    </Link>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Sürgős esetben:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Phone fontSize="small" color="primary" />
                    <Link href="tel:+36204066609" underline="hover">
                        Magyar Martin: +36 20 406 6609
                    </Link>
                </Box>
            </Box>
        </Paper>
    );
};

export default UnderDevelopment; 